// removed by extract-text-webpack-plugin
module.exports = {"jobs":"_3-l_49R_AAB5IPm8NjeGas","title":"_2fjzTTx9F9ofNyPOcNMAQa","vacancyWrapper":"_1xTKN_y4AoFhrEJ5sSIhPc","accordion":"_2mdTSYZk-nKgpFdvnOlV33","list":"_1YadvBPnax1aEgvOwb0M-J","description":"_2QWVzBCzwo7gRO3buurWYV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Jobs/Jobs.scss
// module id = 1608
// module chunks = 0